import { FormFieldType } from '../typings';
import type { RepeatingGroupFormField } from '../typings';

/** True when clearing a group's last instance takes the group off screen. */
export const emptiedGroupDisappears = (
  field: RepeatingGroupFormField,
): boolean => {
  // Mirrors `shouldBeVisible` in use-multiple-field.ts — keep the two in step.
  // shouldBeVisible also keys on isAddedEntry, deliberately not mirrored here:
  // clearing resets ProviderAdded on the server (UpdateFieldService.cs), so a
  // cleared entry always comes back collapsed and isAddedEntry is moot.
  // The staged presenter renders its container only while hasAnyValue, so a
  // clear always falls back to the "none added yet" alert.
  if (field.type === FormFieldType.StagedFieldsGroup) return true;

  // Without a question, only the server knows whether clearing leaves the
  // group with no entry: hidden defaults and G1 record IDs survive a clear.
  return Boolean(field.questionIfOptional) || field.clearsToEmpty === true;
};
